export const formatArticleDate = (iso?: string) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const formatReadTime = (mins?: number) => {
  if (!mins) return "";
  return `${mins} min${mins === 1 ? "" : "s"}`;
};

export const getInitials = (name?: string) => {
  if (!name) return "DB";
  return name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};
